class Bookmark
    constructor: (el) ->
        @.$el = el
        @.disabled = @.$el.classList.contains 'bookmark--disabled' || @.$el.disabled
        @.marked = @.$el.classList.contains 'bookmark--marked'

        @.InitEvents()
        @.$el.classList.add 'bookmark--bound'
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'click', (e) ->
            if !self.disabled
                self.marked = !self.marked
                if self.marked
                    self.$el.dispatchEvent new CustomEvent 'bookmark-marked', { bubbles: true }
                else
                    self.$el.dispatchEvent new CustomEvent 'bookmark-unmarked', { bubbles: true }
                self.$el.classList.toggle 'bookmark--marked'
            return
        return

BindBookmarks = ->
    document.querySelectorAll '.bookmark:not(.bookmark--bound)'
        .forEach (el) ->
            new Bookmark el
            return
    return

window.addEventListener 'bind-components', BindBookmarks

class BookmarkCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bindLater = options?.bindLater ? false
        @.disabled = options?.disabled ? false
        @.id = options?.id ? false
        @.link = options?.link ? false
        @.marked = options?.marked ? false
        @.tag = if @.link then 'a' else (options?.tag ? 'button')

        @.CreateElement()
        if !@.bindLater
            new Bookmark @.$el
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'bookmark'
        if @.id
            @.$el.id = @.id
        if @.tag == 'button'
            @.$el.type = 'button'
            if @.disabled
                @.$el.disabled = true
        else
            if @.disabled
                @.$el.classList.add 'bookmark--disabled'
        if @.tag == 'a' && @.link
            @.$el.href = @.link
        if @.marked
            @.$el.classList.add 'bookmark--marked'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.innerHTML = "
            <span class='bookmark__icon'></span>
        "
        return

window.CreateBookmark = (options) ->
    return new BookmarkCreate options